import { useFormikContext } from 'formik'
import { useGetMasterProducts } from 'hooks/useProducts'
import { ProductCard } from './ProductCard'

type ValuesType = {
  equivalentProducts: { gtin: string; referencedTradeItemTypeCode: string }[]
  alternativeProducts: { gtin: string; referencedTradeItemTypeCode: string }[]
}

export const DisplayRelatedProduct = ({
  product,
  type,
  remove,
}: {
  product: { gtin: string; referencedTradeItemTypeCode: string }
  type: 'equivalentProducts' | 'alternativeProducts'
  remove: (index: number) => void
}) => {
  const { error, products } = useGetMasterProducts(1, 100, product.gtin, 'gtin')
  const { values } = useFormikContext()

  const handleRemoveProduct = (gtin: string) => {
    const index = (values as ValuesType)[type].findIndex(
      (prod) => prod.gtin === gtin
    )
    remove(index)
  }
  if (error || !products || products?.length === 0) return null
  return (
    <ProductCard
      product={products[0]}
      handleDeleteProduct={handleRemoveProduct}
    />
  )
}
